module.exports = __webpack_public_path__ + "media/SetA_T5_A.c30cb357.mp3";